import { render, staticRenderFns } from "./ClinicForm.vue?vue&type=template&id=4fe108e4&scoped=true"
import script from "./ClinicForm.vue?vue&type=script&lang=js"
export * from "./ClinicForm.vue?vue&type=script&lang=js"
import style0 from "./ClinicForm.vue?vue&type=style&index=0&id=4fe108e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe108e4",
  null
  
)

export default component.exports